/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from '../../app/helpers/restClient';

const RESOURCE_PAGE_FACADE = '/cart';
const RESOURCE_ROOT_FACADE = '/checkout';
/**
 * Get order details via the facade layer
 * https://localhost:8080/checkout/cart/{orderId}?brand=flowers
 *
 * @param {*} wcEnv
 * @param {*} orderId
 */
const getOrderDetails = (wcEnv, jwtToken, orderId) => {
    const env = wcEnv;
    env.rootUri = RESOURCE_ROOT_FACADE;
    const resourcePage = `${RESOURCE_PAGE_FACADE}/${orderId}`;

    return restClient.getFacade(env, resourcePage, jwtToken)
        .then((response) => response);
};

export default getOrderDetails;
